import { render, staticRenderFns } from "./accidentReportUpdate.vue?vue&type=template&id=09216084&scoped=true&"
import script from "./accidentReportUpdate.vue?vue&type=script&lang=js&"
export * from "./accidentReportUpdate.vue?vue&type=script&lang=js&"
import style0 from "./accidentReportUpdate.vue?vue&type=style&index=0&id=09216084&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09216084",
  null
  
)

export default component.exports